import {
  ScreenActivity,
  ActivityModel
} from '../../models/activities/activity';

export class OptionalCompleteActivityModel extends ActivityModel {
  constructor(options?: Partial<OptionalCompleteActivityModel>) {
    super(options);

    if (options) {
      Object.assign(this, options);
    }
  }
}

export class OptionalCompleteActivity extends ScreenActivity<
  OptionalCompleteActivityModel
> {
  constructor(options?: Partial<OptionalCompleteActivity>) {
    super(options);

    this.type = 'optional-complete-activity';
    this.description = 'Choose to start activities that follow this activity';
    this.name = 'Optional Complete';

    this.model = new OptionalCompleteActivityModel(
      options ? options.model : null
    );

    this.model.screenName = this.model.screenName || 'Optional to Complete';
  }
}
